import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { FALLBACK_LOGO } from 'constants/brand-fallback'
import { useCustomTheme } from 'contexts/theme'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '200px',
    height: 'auto',
    overflow: 'hidden',
    textAlign: 'left',

    '& img': {
      maxWidth: '100%',
      maxHeight: '100px',
      height: 'auto',
      display: 'block',
      objectFit: 'cover',
      objectPosition: 'center',
    },
  },
}))

const LogoTheme = () => {
  const classes = useStyles()

  const { theme } = useCustomTheme()

  const themeFile = theme.name === 'custom'
    ? (theme.logo.base || FALLBACK_LOGO.base)
    : `/${theme.name}/logo.svg`

  return (
    <div className={classes.root}>
      <img
        src={themeFile}
        alt={theme.name}
        onError={(e) => {
          const target = e.currentTarget
          // invariant: uma troca so. Se o proprio fallback falhar, a imagem some em vez de repetir o pedido em loop.
          if (target.dataset.fallback === 'true') {
            target.hidden = true
            return
          }
          target.dataset.fallback = 'true'
          target.src = FALLBACK_LOGO.base
        }}
      />
    </div>
  )
}

export default LogoTheme
